/**
 * Mock data for E2E testing and local development.
 * Data fetched from http://34.55.225.169:8080/ using X-E2E-Test-Mode: true header.
 *
 * Data structure:
 * - Organization: Acme Corp (e2e-test-org-id)
 * - Workspace: Finance (e2e-test-workspace-id)
 * - Automations:
 *   - SAP Invoice Processing with 4-Way Match (tr11jt5jBCZsvPlEvPs7D)
 *   - Legal Ticket Classification & Routing (HbOf0TehxEd499JDwQWjG)
 *
 * To refresh data, use curl with -H 'X-E2E-Test-Mode: true' header:
 * curl -s 'http://34.55.225.169:8080/api/v1/me' -H 'X-E2E-Test-Mode: true' --insecure
 */

// User data
import meData from './api/v1/me.json';
import meOrganizationsData from './api/v1/me-organizations.json';

// Organization data
import organizationData from './api/v1/organizations/e2e-test-org-id.json';

// Workspace data
import workspacesData from './api/v1/organizations/e2e-test-org-id/workspaces.json';
import workspaceData from './api/v1/organizations/e2e-test-org-id/workspaces/e2e-test-workspace-id.json';

// Automation data
import automationsData from './api/v1/organizations/e2e-test-org-id/workspaces/e2e-test-workspace-id/automations.json';
import automationData from './api/v1/organizations/e2e-test-org-id/workspaces/e2e-test-workspace-id/automations/HbOf0TehxEd499JDwQWjG.json';
// Use runs data for the 4-way match automation (tr11jt5jBCZsvPlEvPs7D) for demo
import automationRunsData from './api/v1/organizations/e2e-test-org-id/workspaces/e2e-test-workspace-id/automations/tr11jt5jBCZsvPlEvPs7D/runs.json';

// Aggregates data
import automationRunAggregatesData from './api/v1/organizations/e2e-test-org-id/workspaces/e2e-test-workspace-id/automation-run-aggregates.json';
import dailyRunAggregatesData from './api/v1/organizations/e2e-test-org-id/workspaces/e2e-test-workspace-id/daily-run-aggregates.json';

// Exceptions data
import exceptionsData from './api/v1/organizations/e2e-test-org-id/workspaces/e2e-test-workspace-id/exceptions.json';

// Library data
import tagsData from './api/v1/tags.json';
import booksLatestData from './api/v1/books-latest.json';

// Connections data
import connectionsData from './api/v1/organizations/e2e-test-org-id/workspaces/e2e-test-workspace-id/connections.json';

// Guide entries data
import guideEntriesData from './api/v1/organizations/e2e-test-org-id/workspaces/e2e-test-workspace-id/all-guideEntries.json';

// Triggers data
import triggersData from './api/v1/organizations/e2e-test-org-id/workspaces/e2e-test-workspace-id/triggers.json';

// Exception groups data
import exceptionGroupsData from './api/v1/organizations/e2e-test-org-id/workspaces/e2e-test-workspace-id/exceptionGroups.json';

// Exception count data
import exceptionsCountByGroupData from './api/v1/organizations/e2e-test-org-id/workspaces/e2e-test-workspace-id/exceptions-countByGroup.json';
import exceptionsCountByAutomationData from './api/v1/organizations/e2e-test-org-id/workspaces/e2e-test-workspace-id/exceptions-countByAutomation.json';

// Automation query data (for :query endpoint)
import automationQueryData from './api/v1/organizations/e2e-test-org-id/workspaces/e2e-test-workspace-id/automations/tr11jt5jBCZsvPlEvPs7D-query.json';

export const mockData = {
  me: meData,
  meOrganizations: meOrganizationsData,
  organization: organizationData,
  workspaces: workspacesData,
  workspace: workspaceData,
  automations: automationsData,
  automation: automationData,
  automationRuns: automationRunsData,
  automationRunAggregates: automationRunAggregatesData,
  dailyRunAggregates: dailyRunAggregatesData,
  exceptions: exceptionsData,
  tags: tagsData,
  booksLatest: booksLatestData,
  connections: connectionsData,
  guideEntries: guideEntriesData,
  triggers: triggersData,
  exceptionGroups: exceptionGroupsData,
  exceptionsCountByGroup: exceptionsCountByGroupData,
  exceptionsCountByAutomation: exceptionsCountByAutomationData,
  automationQuery: automationQueryData,
};

export {
  meData,
  meOrganizationsData,
  organizationData,
  workspacesData,
  workspaceData,
  automationsData,
  automationData,
  automationRunsData,
  automationRunAggregatesData,
  dailyRunAggregatesData,
  exceptionsData,
  tagsData,
  booksLatestData,
  connectionsData,
  guideEntriesData,
  triggersData,
  exceptionGroupsData,
};

export default mockData;
